import AppStylesProvider from 'web/contexts/AppStylesContext';
import GraphqlProvider from 'web/contexts/GraphqlContext';
import AppDataProvider from 'web/contexts/AppDataContext';
import UserProvider from 'web/contexts/UserContext';
import SnackbarProvider from 'web/contexts/SnackbarContext';

export default function AppProviders({ children }) {
	return (
		<AppStylesProvider>
			<GraphqlProvider>
				<AppDataProvider>
					<SnackbarProvider>
						<UserProvider>{children}</UserProvider>
					</SnackbarProvider>
				</AppDataProvider>
			</GraphqlProvider>
		</AppStylesProvider>
	);
}
